import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default {
  success: function (message) {
    toast.success(message);
  },
  info: function (message) {
    toast.info(message);
  },
  warn: function (message) {
    toast.warn(message);
  },
  error: function (message) {
    toast.error(message);
  },
};
